// Third-party library imports and global exposure for transitchat application
// This file consolidates all external dependencies and makes them available globally
// for compatibility with server-side rendered templates and HTMX interactions

// Alpine.js - JavaScript framework for reactive interfaces
import Alpine from 'alpinejs';


// Chart.js - Canvas-based charts
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  RadialLinearScale
} from 'chart.js';

// HTMX - High power tools for HTML
import htmx from 'htmx.org';

// Mapbox GL JS - Vector maps
import mapboxgl from 'mapbox-gl';

// Quill - Rich text editor
import Quill from 'quill';

// NanoID - URL-friendly unique ID generator
import { nanoid } from 'nanoid';

// Sortable.js - Drag and drop for lists
// @ts-ignore - Sortable.js types not available
import Sortable from 'sortablejs';

// Configure Chart.js with required components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  RadialLinearScale
);

// Expose libraries globally for template compatibility
window.Alpine = Alpine;
window.Chart = ChartJS;
window.htmx = htmx;
window.mapboxgl = mapboxgl;
window.Quill = Quill;
window.nanoid = nanoid;
window.Sortable = Sortable;

// Initialize Alpine.js
Alpine.start();

// Initialize HTMX
htmx.logAll();

// Export for module usage
export {
  Alpine,
  ChartJS as Chart,
  htmx,
  mapboxgl,
  Quill,
  nanoid,
  Sortable
};

// Log successful initialization
console.log('[TransitChat] All vendor libraries loaded successfully:', {
  Alpine: !!window.Alpine,
  Chart: !!window.Chart,
  htmx: !!window.htmx,
  mapboxgl: !!window.mapboxgl,
  Quill: !!window.Quill,
  nanoid: !!window.nanoid,
  Sortable: !!window.Sortable
});
